<template>
  <div class="side-panel">
    <div class="panel__header">
      <div class="title">{{ sideData.code }}面</div>
      <div class="extra">
        <div v-if="!isBottomLayer" class="cells-count-input q-ml-lg">
          格口数：
          <el-input-number
            v-model="currentCellsCount"
            @change="handleCellsNumberChange"
            :min="1"
            :max="4"
            step-strictly
          ></el-input-number>
        </div>
      </div>
    </div>

    <div class="panel__body">
      <div v-if="currentCells.length" class="cells-wrapper">
        <div class="cell-item" v-for="it in currentCells" :style="{ flex: it.span || 1 }">
          <cell-panel :cell-data="it" :disabled="disabled" />
        </div>
      </div>
      <div v-else class="no-data">此面没有配置格口</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from '@zto/zpage'

import CellPanel from './cell-panel.vue'

const props = defineProps<{
  sideData: any
  layerNumber: number
  disabled: boolean
}>()

const currentCellsCount = ref<number>(0)

const currentCells = computed(() => {
  return props.sideData.cells || []
})

// 是否底层，底层固定1个格口
const isBottomLayer = computed(() => {
  return props.layerNumber === 1
})

watch(
  () => currentCells.value.length,
  cur => {
    currentCellsCount.value = cur
  },
  { immediate: true }
)

watch(
  () => props.layerNumber,
  () => {
    // 底层，并且当前格口数量长度不为空，则默认格口数量为1
    if (!currentCells.value.length) {
      adjustCellsByNumber(1)
    }
  },
  { immediate: true }
)

// 调整格口数
function handleCellsNumberChange(num: number) {
  adjustCellsByNumber(num)
}

function adjustCellsByNumber(num: number) {
  const cells = currentCells.value || []

  // 格口大小按24均分
  let span = 24
  if (num > 0) {
    span = Number((24 / num).toFixed(2))
  }

  while (num > cells.length) {
    cells.push({
      layer: props.layerNumber,
      side: props.sideData.code,
      name: '格口',
      num: '',
      span,
      pos: cells.length
    })
  }

  // 移除最后一个
  while (num < cells.length) {
    cells.pop()
  }

  cells.forEach((it: any) => {
    it.span = span
  })

  props.sideData.cells = cells
}
</script>

<style lang="scss" scoped>
.side-panel {
  border: 1px solid #f0f0f0;
  border-radius: 5px;

  .panel {
    &__header {
      display: flex;
      align-items: center;
      padding: 10px 20px;
      background-color: #fafafa;
      border-bottom: 1px solid #f0f0f0;

      .title {
        flex: 1;
      }

      .extra {
        display: flex;
        align-items: center;
      }
    }
  }
}

.no-data {
  height: 120px;
}

.cells-wrapper {
  display: flex;
  min-height: 120px;
  gap: 5px;

  padding: 10px;
  box-sizing: border-box;
}
</style>
